import { get, post ,get1} from '@/request/http'

//月度各指标数值和同比
export const getmonthindexdata = (params) => get('/api/home/getmonthindexdata', params)

//开工销售比接口
export const getkgxsper = (params) => get('/api/home/getkgxsper', params)


//年度城与全图倍数比
export const getcityperall = (params) => get('/api/home/getcityperall', params)

//月度城与全图倍数比
export const getmonthcityperall = (params) => get('/api/home/getmonthcityperall', params)


//年度城与全图同比对比
export const getcitytongbiall = (params) => get('/api/home/getcitytongbiall', params)

//月度城与全图同比对比
export const getmonthcitytongbiall = (params) => get('/api/home/getmonthcitytongbiall', params)


// WEBPACK FOOTER //
// ./src/api/reading.js